import { render } from "./HoraStats.vue?vue&type=template&id=3e2710a1&scoped=true"
import script from "./HoraStats.vue?vue&type=script&lang=js"
export * from "./HoraStats.vue?vue&type=script&lang=js"

import "./HoraStats.vue?vue&type=style&index=0&id=3e2710a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2710a1"]])

export default __exports__